
if(typeof BSS_B2B !== 'undefined' && window.location.pathname === '/account/register') {
  setTimeout(() => {
                let companyField = document.querySelector("#text-1700819396352-0")
                let companyLabel = document.querySelector('label[for*="text-1700819396352-0"]')
                let phoneField = document.querySelector("#text-1700819375868-0")
                let phoneLabel = document.querySelector('label[for*="text-1700819375868-0"]')
                let countryField = document.getElementById("text-1700819407919-0")
                let countryLabel = document.querySelector('label[for*="text-1700819407919-0"]')

                let vatField = document.getElementById("vat-validation")
                let vatLabel = document.querySelector('label[for*="vat-validation"]')
                companyField.addEventListener("focus", () => {
                  companyLabel.style.fontSize = '1rem';
                  companyLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                  companyLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                  companyLabel.style.letterSpacing = '0.04rem';
                  companyField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                  companyField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                })
                companyField.addEventListener("blur", () => {
                  if(companyField.value.trim() === "") {
                    companyLabel.style.fontSize = '1.6rem';
                    companyLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                    companyLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    companyLabel.style.letterSpacing = '0.1rem';
                    companyField.style.boxShadow = "none";
                    companyField.style.padding = "6px 12px";  
                  }
                })

                phoneField.addEventListener("focus", () => {
                    phoneLabel.style.fontSize = '1rem';
                    phoneLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                    phoneLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    phoneLabel.style.letterSpacing = '0.04rem';
                    phoneField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                    phoneField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                  })
                  phoneField.addEventListener("blur", () => {
                    if(phoneField.value.trim() === "") {
                      phoneLabel.style.fontSize = '1.6rem';
                      phoneLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                      phoneLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                      phoneLabel.style.letterSpacing = '0.1rem';
                      phoneField.style.boxShadow = "none";
                      phoneField.style.padding = "6px 12px";  
                    }
                  })

              countryField.addEventListener("focus", () => {
                    countryLabel.style.fontSize = '1rem';
                    countryLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                    countryLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    countryLabel.style.letterSpacing = '0.04rem';
                    countryField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                    countryField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                  })
                  countryField.addEventListener("blur", () => {
                    if(countryField.value.trim() === "") {
                      countryLabel.style.fontSize = '1.6rem';
                      countryLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                      countryLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                      countryLabel.style.letterSpacing = '0.1rem';
                      countryField.style.boxShadow = "none";
                      countryField.style.padding = "6px 12px";  
                    }
                  })
                   vatField.addEventListener("focus", () => {
                    vatLabel.style.fontSize = '1rem';
                    vatLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                    vatLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    vatLabel.style.letterSpacing = '0.04rem';
                    vatField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                    vatField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                  })
                  vatField.addEventListener("blur", () => {
                    if(vatField.value.trim() === "") {
                      vatLabel.style.fontSize = '1.6rem';
                      vatLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                      vatLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                      vatLabel.style.letterSpacing = '0.1rem';
                      vatField.style.boxShadow = "none";
                      vatField.style.padding = "6px 12px";  
                    }
                  })

    let form = document.querySelectorAll("#bss-b2b-registration-form-render") 
    if (form.length > 1) {
        form[1].remove()
    }
},200) }

if(typeof BSS_B2B !== 'undefined' && window.location.pathname === '/pages/private-label-application') {
  setTimeout(() => {
                let fields = document.querySelectorAll(".form-control");
                fields.forEach(field => field.placeholder = '')
                let companyField = document.querySelector(".company-field")
                let companyLabel = document.querySelector('label[for*="company-field"]')
                let phoneField = document.querySelector(".phone-field")
                let phoneLabel = document.querySelector('label[for="phone-field"]')
                let orgField = document.getElementById("text-1699549458080-0")
                let orgLabel = document.querySelector('label[for="text-1699549458080-0"]')
                let firstNameField = document.getElementById("RegisterForm-FirstName")
                let firstNameLabel = document.querySelector('label[for="RegisterForm-FirstName"]')
                let lastNameField = document.getElementById("RegisterForm-LastName")
                let lastNameLabel = document.querySelector('label[for="RegisterForm-LastName"]')
                let emailField = document.getElementById("RegisterForm-email")
                let emailLabel = document.querySelector('label[for="RegisterForm-email"]')
                let passwordField = document.getElementById("RegisterForm-password")
                let passwordLabel = document.querySelector('label[for="RegisterForm-password"]')

                firstNameField.addEventListener("focus", () => {
                  firstNameLabel.style.fontSize = '1rem';
                  firstNameLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                  firstNameLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                  firstNameLabel.style.letterSpacing = '0.04rem';
                  firstNameField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                  firstNameField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                })
                firstNameField.addEventListener("blur", () => {
                  if(firstNameField.value.trim() === "") {
                    firstNameLabel.style.fontSize = '1.6rem';
                    firstNameLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                    firstNameLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    firstNameLabel.style.letterSpacing = '0.1rem';
                    firstNameField.style.boxShadow = "none";
                    firstNameField.style.padding = "6px 12px";  
                  }
                })

    lastNameField.addEventListener("focus", () => {
                  lastNameLabel.style.fontSize = '1rem';
                  lastNameLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                  lastNameLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                  lastNameLabel.style.letterSpacing = '0.04rem';
                  lastNameField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                  lastNameField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                })
                lastNameField.addEventListener("blur", () => {
                  if(lastNameField.value.trim() === "") {
                    lastNameLabel.style.fontSize = '1.6rem';
                    lastNameLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                    lastNameLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    lastNameLabel.style.letterSpacing = '0.1rem';
                    lastNameField.style.boxShadow = "none";
                    lastNameField.style.padding = "6px 12px";  
                  }
                })

    emailField.addEventListener("focus", () => {
                  emailLabel.style.fontSize = '1rem';
                  emailLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                  emailLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                  emailLabel.style.letterSpacing = '0.04rem';
                  emailField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                  emailField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                })
                emailField.addEventListener("blur", () => {
                  if(emailField.value.trim() === "") {
                    emailLabel.style.fontSize = '1.6rem';
                    emailLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                    emailLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    emailLabel.style.letterSpacing = '0.1rem';
                    emailField.style.boxShadow = "none";
                    emailField.style.padding = "6px 12px";  
                  }
                })

    passwordField.addEventListener("focus", () => {
                  passwordLabel.style.fontSize = '1rem';
                  passwordLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                  passwordLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                  passwordLabel.style.letterSpacing = '0.04rem';
                  passwordField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                  passwordField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                })
                passwordField.addEventListener("blur", () => {
                  if(passwordField.value.trim() === "") {
                    passwordLabel.style.fontSize = '1.6rem';
                    passwordLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                    passwordLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    passwordLabel.style.letterSpacing = '0.1rem';
                    passwordField.style.boxShadow = "none";
                    passwordField.style.padding = "6px 12px";  
                  }
                })



    
                companyField.addEventListener("focus", () => {
                  companyLabel.style.fontSize = '1rem';
                  companyLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                  companyLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                  companyLabel.style.letterSpacing = '0.04rem';
                  companyField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                  companyField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                })
                companyField.addEventListener("blur", () => {
                  if(companyField.value.trim() === "") {
                    companyLabel.style.fontSize = '1.6rem';
                    companyLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                    companyLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    companyLabel.style.letterSpacing = '0.1rem';
                    companyField.style.boxShadow = "none";
                    companyField.style.padding = "6px 12px";  
                  }
                })

                phoneField.addEventListener("focus", () => {
                    phoneLabel.style.fontSize = '1rem';
                    phoneLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                    phoneLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    phoneLabel.style.letterSpacing = '0.04rem';
                    phoneField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                    phoneField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                  })
                  phoneField.addEventListener("blur", () => {
                    if(phoneField.value.trim() === "") {
                      phoneLabel.style.fontSize = '1.6rem';
                      phoneLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                      phoneLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                      phoneLabel.style.letterSpacing = '0.1rem';
                      phoneField.style.boxShadow = "none";
                      phoneField.style.padding = "6px 12px";  
                    }
                  })

              orgField.addEventListener("focus", () => {
                    orgLabel.style.fontSize = '1rem';
                    orgLabel.style.top = `calc(var(--inputs-border-width) + 0.5rem)`;
                    orgLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                    orgLabel.style.letterSpacing = '0.04rem';
                    orgField.style.boxShadow = "0 0 0 1px rgba(var(--color-foreground)) !important";
                    orgField.style.padding = "2.2rem 1.5rem 0.8rem 2rem";  
                  })
                  orgField.addEventListener("blur", () => {
                    if(orgField.value.trim() === "") {
                      orgLabel.style.fontSize = '1.6rem';
                      orgLabel.style.top = `calc(1rem + var(--inputs-border-width))`;
                      orgLabel.style.left = `calc(var(--inputs-border-width) + 2rem)`;
                      orgLabel.style.letterSpacing = '0.1rem';
                      orgField.style.boxShadow = "none";
                      orgField.style.padding = "6px 12px";  
                    }
                  })

              let icon = document.querySelectorAll(".icon-show-hide-password")
    if (icon.length > 1) {
      icon[1].remove()
    }
              },200)
}



